import React, { useContext } from 'react';
import { LinearProgress } from '@material-ui/core';
import { useHistory } from 'react-router';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ColoredPaper } from '../bos_common/src';

import { AppContext } from '../context/AppContext';
import MerchantOrderingConfig from '../components/MerchantOrderingConfig';
import useFetchMerchant from '../services/useFetchMerchant';

interface IMerchantOrderingConfigProps {
  merchantUsername: string;
}

const MerchantOrderingConfigPage = () => {
  const history = useHistory();
  const { merchantUsername } = useParams<IMerchantOrderingConfigProps>();
  const { merchant, setMerchant } = useContext(AppContext);
  const { t } = useTranslation();

  const onBack = () => {
    history.goBack();
  };

  if (!merchantUsername) {
    history.push(`/biz/create`);
  }

  const loading = useFetchMerchant({ merchantUsername })

  return (
    <div className="container">
      {loading && <LinearProgress />}
      {!loading && (
        <ColoredPaper>
          <MerchantOrderingConfig merchant={merchant} onUpdatedMerchant={setMerchant} />
        </ColoredPaper>
      )}
    </div>
  );
};

export default MerchantOrderingConfigPage;
